import { Link, useLocation } from "react-router-dom";
import { LogOut, ClipboardList, BarChart3, Truck, Users as UsersIcon, Contact } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ROLE_LABEL } from "@/lib/api";

export function AppHeader({ title, subtitle, right }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const isAdmin = user?.role === "admin";
  const isStaff = user?.role === "admin" || user?.role === "personel";

  return (
    <header className="app-header border-b-2 border-zinc-200 bg-white sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-10 h-10 bg-zinc-950 text-white flex items-center justify-center shrink-0">
            <Truck strokeWidth={2.5} size={20} />
          </div>
          <div className="min-w-0">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 truncate">
              {subtitle || "Sipariş Takip"}
            </div>
            <div className="font-black tracking-tight text-zinc-950 truncate">
              {title || "Sipariş Yönetimi"}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {isStaff && (
            <nav className="hidden md:flex items-center gap-1 mr-2">
              <NavLink to="/orders" active={loc.pathname.startsWith("/orders")} icon={<ClipboardList size={14} />}>
                Siparişler
              </NavLink>
              <NavLink to="/customers" active={loc.pathname.startsWith("/customers")} icon={<Contact size={14} />}>
                Müşteriler
              </NavLink>
              {isAdmin && (
                <>
                  <NavLink to="/reports" active={loc.pathname.startsWith("/reports")} icon={<BarChart3 size={14} />}>
                    Raporlar
                  </NavLink>
                  <NavLink to="/users" active={loc.pathname.startsWith("/users")} icon={<UsersIcon size={14} />}>
                    Kullanıcılar
                  </NavLink>
                </>
              )}
            </nav>
          )}

          {right}

          <div className="text-right hidden sm:block px-2">
            <div className="text-xs font-bold text-zinc-950 truncate max-w-[120px]">{user?.display_name}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">
              {ROLE_LABEL[user?.role] || user?.role}
            </div>
          </div>

          <button
            data-testid="logout-button"
            onClick={logout}
            className="flex items-center gap-1.5 px-3 py-2 bg-zinc-950 text-white text-xs font-bold uppercase tracking-wider hover:bg-zinc-800 transition-colors"
          >
            <LogOut size={14} strokeWidth={2.5} />
            <span className="hidden sm:inline">Çıkış</span>
          </button>
        </div>
      </div>

      {isStaff && (
        <nav className="md:hidden flex border-t border-zinc-200">
          <MobileLink to="/orders" active={loc.pathname.startsWith("/orders")} icon={<ClipboardList size={14} />} label="Sipariş" />
          <MobileLink to="/customers" active={loc.pathname.startsWith("/customers")} icon={<Contact size={14} />} label="Müşteri" />
          {isAdmin && (
            <>
              <MobileLink to="/reports" active={loc.pathname.startsWith("/reports")} icon={<BarChart3 size={14} />} label="Rapor" />
              <MobileLink to="/users" active={loc.pathname.startsWith("/users")} icon={<UsersIcon size={14} />} label="Kullanıcı" />
            </>
          )}
        </nav>
      )}
    </header>
  );
}

function NavLink({ to, active, icon, children }) {
  return (
    <Link
      to={to}
      data-testid={`nav-${to.replace("/", "")}`}
      className={`inline-flex items-center gap-1.5 px-3 py-2 text-xs font-bold uppercase tracking-wider border-2 transition-colors ${
        active ? "bg-zinc-950 text-white border-zinc-950" : "bg-white text-zinc-700 border-zinc-200 hover:border-zinc-950"
      }`}
    >
      {icon}
      {children}
    </Link>
  );
}

function MobileLink({ to, active, icon, label }) {
  return (
    <Link
      to={to}
      data-testid={`mnav-${to.replace("/", "")}`}
      className={`flex-1 flex items-center justify-center gap-2 py-2 text-xs font-bold uppercase tracking-wider ${
        active ? "bg-zinc-950 text-white" : "bg-white text-zinc-700"
      }`}
    >
      {icon}
      {label}
    </Link>
  );
}
